import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export default function useUpdateParticipantRole(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  return useMutation(
    async ({
      gameId,
      phone,
      role,
    }: {
      gameId: string;
      phone: string;
      role: 'contributor' | 'viewer';
    }) => {
      const response = await ChessRestClient.post(
        `learning/study_games/${gameId}/participants/role/`,
        {phone_number: phone, role},
      );
      return response.data;
    },
    {
      onSuccess: data => {
        handleOnSuccess?.(data);
      },
      onError: error => {
        handleOnError?.(error);
      },
    },
  );
}
